import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import SaveIcon from '@material-ui/icons/SaveRounded';

import Page from '../../components/Page';

import styled from './UserProfileStyles';

import UserPhoto from '../../components/UserPhoto';

import UserTabs from './UserTabs';

import { actions as profileActions } from '../../services/userProfile';

class UserProfile extends React.Component {
  state = {
    saveInProgress: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.userId !== this.props.match.params.userId) {
      this.props.actions.load(this.props.match.params.userId);
    }
  }

  componentDidMount() {
    this.props.actions.load(this.props.match.params.userId);
  }

  renderPhotos() {
    const { data, classes } = this.props;
    if (!Array.isArray(data.photos)) {
      return <div />;
    }
    return (
      <Paper className={classes.photosContainer}>
        <div className={classes.photoList}>
          {data.photos.map((photo, index) => (
            <UserPhoto
              key={photo._id + index}
              user={data}
              photo={index}
              className={classes.userPhoto}
            />
          ))}
        </div>
      </Paper>
    );
  }

  save = async () => {
    this.setState({
      saveInProgress: true
    });
    await this.props.actions.saveData();
    this.setState({
      saveInProgress: false
    });
  };

  renderProfile() {
    const { data, modified, classes } = this.props;

    return (
      <div>
        <Typography variant="h6">{`${data.firstName} ${
          data.lastName
        }, ${moment().diff(new Date(data.dob), 'years')}`}</Typography>
        {this.renderPhotos()}
        <UserTabs />

        <Zoom in={modified} timeout={200} unmountOnExit>
          <Fab
            disabled={this.state.saveInProgress}
            variant="extended"
            aria-label="Delete"
            className={classes.saveBtn}
            color="secondary"
            onClick={this.save}
          >
            <SaveIcon className={classes.saveIcon} />
            Save
          </Fab>
        </Zoom>
      </div>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Page title="User Profile" loading={loading}>
        {loading ? <div /> : this.renderProfile()}
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.userProfile.loading,
    data: state.userProfile.data,
    modified: state.userProfile.modified
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: userId => dispatch(profileActions.load(userId)),
    saveData: () => dispatch(profileActions.saveData())
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(UserProfile))
);
